/** @format */

import React from "react";
import { createRoot } from "react-dom/client";

import "./index.scss";
import { store } from "./app/store";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import "./i18n/init";
import AnalyticsProviderWithCookieBanner from "./features/analytics/AnalyticsProvider";
import AppRouter from "./AppRouter";

const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AnalyticsProviderWithCookieBanner>
        <AppRouter />
      </AnalyticsProviderWithCookieBanner>
    </Provider>
  </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
